jQuery(function($) {

    $(window).load(function(){
        initTestimonialSlider();
    });

    function initTestimonialSlider() {
        $('.d6-block--testimonial-callout .testimonial-inner-ctn').each(function(){
            
            // on init
            $(this).on('init', function(event, slick){
                $(this).css('display', 'unset');
                $(this).fadeTo(1000, 1);
            });

            $(this).slick({
    
                // general options
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                adaptiveHeight: true,
                dots: true,
    
                // custom options
                autoplay: $(this).data('autoplay'),
                autoplaySpeed: $(this).data('slide_duration'),
                prevArrow: '<div class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg data-name="Elem_Lrg Grey Arrow"height=53.058 id=Elem_Lrg_Grey_Arrow viewBox="0 0 52.602 53.058"width=52.602 xmlns=http://www.w3.org/2000/svg><g id=Elem_Lrg_Red_Arrow transform="translate(-24 -23)"data-name="Elem_Lrg Red Arrow"><g id=arrow transform="translate(-12.572 -14.961)"><path d=M61.09,22.515,84.969,46.391h-48.4v2.2h48.4L61.09,72.466l1.553,1.553L87.621,49.042l1.553-1.553-1.553-1.553L62.643,20.961Z data-name="Path 5157"id=Path_5157 transform="translate(0 17)"/></g></g></svg></div>',
                nextArrow: '<div class="slick-next slick-arrow" aria-label="Next" type="button"><svg data-name="Elem_Lrg Grey Arrow"height=53.058 id=Elem_Lrg_Grey_Arrow viewBox="0 0 52.602 53.058"width=52.602 xmlns=http://www.w3.org/2000/svg><g id=Elem_Lrg_Red_Arrow transform="translate(-24 -23)"data-name="Elem_Lrg Red Arrow"><g id=arrow transform="translate(-12.572 -14.961)"><path d=M61.09,22.515,84.969,46.391h-48.4v2.2h48.4L61.09,72.466l1.553,1.553L87.621,49.042l1.553-1.553-1.553-1.553L62.643,20.961Z data-name="Path 5157"id=Path_5157 transform="translate(0 17)"/></g></g></svg></div>',

            });
        });
    } 
});